import { CustomPortableText } from '@workspace/ui/PortableText';
import { ProductSummaryCTA } from './ProductSummaryCTA';
import { ProductSummaryHeading } from './ProductSummaryHeading';
import { CTAItem } from '../product-summary.types';

interface ProductSummaryContentProps {
  resolvedHeadingText: string;
  headingFontClass: string;
  description?: any[];
  ctaUnderHeadline: CTAItem[];
  ctaUnderDescription: CTAItem[];
  onAskGregClick: () => void;
  getOpenInNewTab: (item: CTAItem) => boolean;
}

export function ProductSummaryContent({
  resolvedHeadingText,
  headingFontClass,
  description,
  ctaUnderHeadline,
  ctaUnderDescription,
  onAskGregClick,
  getOpenInNewTab,
}: ProductSummaryContentProps) {
  return (
    <div className="flex flex-col flex-1 gap-sm md:gap-lg w-full">
      <div className="flex flex-col items-start text-left gap-8">
        {resolvedHeadingText && (
          <ProductSummaryHeading text={resolvedHeadingText} headingFontClass={headingFontClass} />
        )}
        <ProductSummaryCTA
          ctaItems={ctaUnderHeadline}
          onAskGregClick={onAskGregClick}
          getOpenInNewTab={getOpenInNewTab}
        />
      </div>

      <div className="flex flex-col gap-8 md:max-w-175">
        {Array.isArray(description) && description.length > 0 && (
          <div className="rich-text-container">
            <CustomPortableText value={description || []} />
          </div>
        )}

        <ProductSummaryCTA
          ctaItems={ctaUnderDescription}
          onAskGregClick={onAskGregClick}
          getOpenInNewTab={getOpenInNewTab}
        />
      </div>
    </div>
  );
}
